/*
    MAIN.JS

    - Last updated: 05.05.19
    - NOTES:
		https://github.com/vuejs-templates/webpack-simple/issues/29
		https://eslint.org/docs/rules/no-new
*/

import Vue from 'vue';
import App from './App';
import router from './router/router';
import store from './store/store';
import firebase from '@/config/firebase';

import 'latest-createjs/lib/preloadjs/preloadjs';
import 'latest-createjs/lib/soundjs/soundjs';

Vue.config.productionTip = false;

let app;

firebase.auth().onAuthStateChanged(() => {
	if (!app) {
		/*eslint no-new: "error"*/
		app = new Vue({
			router,
			store,
			render: h => h(App)
		}).$mount('#app');
	}
});